import { Stack, StackProps, Typography, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useCountdown } from 'usehooks-ts';

import { IconProps } from './Icon.interface';

import { LoopDotsContainer, Spinner } from './Icon.styled';

type LoaderProps = {
  text?: string;
  iconProps?: Partial<IconProps>;
} & StackProps;

export function Loader({ text, iconProps, ...props }: LoaderProps) {
  const theme = useTheme();
  return (
    <Stack gap={1} {...props}>
      <Spinner name="spinner" size={32} {...iconProps} />
      {text && (
        <Typography variant="body2" color={theme.palette.text.secondary}>
          {text}
          <LoopDots />
        </Typography>
      )}
    </Stack>
  );
}

function LoopDots() {
  const [count, { startCountdown, resetCountdown }] = useCountdown({
    countStart: 4,
    intervalMs: 500,
  });

  useEffect(() => {
    if (count === 0) {
      resetCountdown();
    } else if (count === 4) {
      startCountdown();
    }
  }, [count, resetCountdown, startCountdown]);

  return (
    <LoopDotsContainer>
      {Array(4 - count)
        .fill('.')
        .join('')}
    </LoopDotsContainer>
  );
}
